var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFill = function SvgStarFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 17.688-3.89 2.347a.72.72 0 0 1-.436.106.8.8 0 0 1-.396-.147.84.84 0 0 1-.273-.332.65.65 0 0 1-.03-.453l1.032-4.417-3.434-2.973a.74.74 0 0 1-.245-.387.7.7 0 0 1 .027-.428.85.85 0 0 1 .233-.34.8.8 0 0 1 .416-.172l4.532-.396 1.76-4.171a.68.68 0 0 1 .291-.344.82.82 0 0 1 .825 0 .68.68 0 0 1 .291.344l1.76 4.171 4.533.396a.8.8 0 0 1 .415.172q.152.132.233.34a.7.7 0 0 1 .028.428.74.74 0 0 1-.245.387l-3.435 2.973 1.033 4.417a.65.65 0 0 1-.031.453.84.84 0 0 1-.273.332.8.8 0 0 1-.395.147.72.72 0 0 1-.436-.106z"
  })));
};
export default SvgStarFill;